<mat-drawer-container (backdropClick)="onBackdropClick()">
  <mat-drawer
    #drawer
    mode="over"
    [opened]="isDrawerOpen()"
    position="start"
    class="w-[85%]">
    <hub-sidebar-navigation [isMobile]="true"></hub-sidebar-navigation>
  </mat-drawer>
  <mat-drawer-content [class.content-drawer-opened]="drawer.opened">
    <!-- Page content -->
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
